"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTemplateTextSettingsForType = exports.defaultStyleForTemplateStyles = void 0;
const template_style_set_1 = require("../../templates/template-style-set");
/**
 * Placeholder function for future more fine-grained default style selection.
 */
const defaultStyleForTemplateStyles = (templateStyles, id) => {
    const styleSet = id && templateStyles.find((styleSet) => styleSet.id === id);
    if (styleSet) {
        return styleSet.styles[0];
    }
    return templateStyles[0]?.styles[0];
};
exports.defaultStyleForTemplateStyles = defaultStyleForTemplateStyles;
function defaultTemplateTextSettingsForType(type = 'body') {
    return {
        typographyType: type,
        ...(0, exports.defaultStyleForTemplateStyles)(template_style_set_1.LessonUpStyleSets, type),
    };
}
exports.defaultTemplateTextSettingsForType = defaultTemplateTextSettingsForType;
//# sourceMappingURL=defaultStyle.js.map